import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import WorkersCompensationRatesLogo from "@components/workerscompensationrates/logo";

import WorkersCompensationRatesWrapper from "@components/layouts/workersCompensationRatesWrapper";
import colors from "@styles/variables/workersCompensationRatesVariables.module.scss";
import Header from "@components/shared/header";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <WorkersCompensationRatesWrapper>
            <Header
                textColor={colors.headerPhoneColor}
                backGroundColor="transparent"
                slogan="the best workers compensation rates"
            >
                <WorkersCompensationRatesLogo />
            </Header>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#694a9e" />
                </div>
                <FormSection iconsFillColor="#694a9e" />
            </div>
        </WorkersCompensationRatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
